import React, { Component } from 'react'
import { Col, Row } from 'reactstrap'
import { inject, observer } from 'mobx-react'
import { formatNullableValue } from '../../../utils/formatar';

@inject("store")
@observer
export default class CardAcomp extends Component {
    render() {
        return (
            <Col xs={12} md={6} lg={4} >
                <div className="card-booking">
                    <Row>
                        {this.props.colunas.map((col, index) => {
                            if(col.hidden) {
                                return null
                            } else {
                                return (
                                    <Col xs={6} className="px-0" key={index}>
                                        <div className="info bg-cinza">
                                            <div className="titulo">{col.text}</div>
                                                <div className={`valor valor-acompanhamento ${col.classes ? col.classes : ""}`}>{
                                                    (col.formatter ?
                                                        (
                                                            col.formatExtraData ?
                                                            formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data), col, null, col.formatExtraData))
                                                            :
                                                            formatNullableValue(col.formatter(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)))
                                                        )
                                                        :
                                                        formatNullableValue(col.dataField.split('.').reduce((o,i)=>o[i], this.props.data)))
                                                }</div>
                                        </div>
                                    </Col>
                                )
                            }
                        })}
                    </Row>
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/acompanhamento/components/CardAcomp.js